import URL from 'url-parse';

export default class URLField extends URL {
  isValid() {
    return this.hostname !== 'localhost';
  }
}



// WEBPACK FOOTER //
// ./src/models/URLField.js